module.exports = __webpack_public_path__ + "img/trainImg.768bec6c.png";